export default "__VITE_ASSET__ynVpDvtN__"